import main from './main.container';

export default main;
